import firebase from '@/vcs/_shared/firebase.js'

import IsChromeDesktop from '@/mixins/is-chrome-desktop.js'
import IsChromeAndroid from '@/mixins/is-chrome-android.js'
import IsFirefoxDesktop from '@/mixins/is-firefox-desktop.js'
import UpdateUserActivity from '@/mixins/update-user-activity.js'
import SendDeviceToken from '@/mixins/send-device-token.js'

import NotificationBlockedReminderModal from '@/vcs/_shared/modals/push-notification-modals/notification-blocked-reminder-modal/cmp.vue'

export default {
  mixins: [IsChromeDesktop, IsChromeAndroid, IsFirefoxDesktop, UpdateUserActivity, SendDeviceToken],
  methods: {
    async isFcmEnabled() {
      let platform = ''
      if (this.isChromeAndroid) {
        platform = 'chrome-android'
      } else if (this.isChromeDesktop) {
        platform = 'chrome-desktop'
      } else if (this.isFirefoxDesktop) {
        platform = 'firefox-desktop'
      }

      try {
        const messaging = firebase.messaging()
        await messaging.requestPermission()
        const token = await messaging.getToken()

        // when user changed his choice push_notifications_allowed to true
        if (JSON.parse(localStorage.getItem('push_notifications_allowed')) == false) {
          this.notificationAllowance(platform, true)
        }

        this.sendDeviceToken(token, 'web')
      } catch (error) {
        console.error('---- flowFCM error 2, no token ----', error)

        // when user changed his choice push_notifications_allowed to false
        if (JSON.parse(localStorage.getItem('push_notifications_allowed')) == true) {
          this.notificationAllowance(platform, false)
        }

        this.$store.commit('modal/open', {
          cmp: NotificationBlockedReminderModal,
          animation: 'slide-down-menu',
        })
      }
    },

    notificationAllowance(platform, value) {
      this.updateUserActivity(platform, 'push_notification_allowance', value)
      localStorage.setItem('push_notifications_allowed', value)
    },
  },
}
